





































import Vue from "vue";
import PremiumBtn from "@/components/premium/PremiumBtn.vue";
import AppCheckbox from "@/components/AppCheckbox.vue";
import { EventBus } from "@/eventbus";
import FolderPath from "./FolderPath.vue";
export default Vue.extend({
  props: ["source"],
  components: {
    AppCheckbox,
    PremiumBtn,
    FolderPath,
  },
  setup(props) {
    const checkChange = () => {
      // @ts-ignore
      if (props.source.disable) {
        return;
      }
      // eventBusType
      const source = props.source as { type: string; eventBusType?: string };
      const typeTag: string = source.eventBusType || source.type;
      EventBus.emit("transfer-check-" + typeTag, {
        item: props.source,
        check: !(props.source as { checked: boolean }).checked,
      });
    };
    return {
      checkChange,
    };
  },
});
